import { UseFormReturn } from "react-hook-form";
import { AsyncAutoCompleteNew } from "../../../async-auto-complete/AsyncAutoCompleteNew";

type TechnicianFieldProps = {
    entityForm: UseFormReturn;
    ageGroupsSelected: number | undefined;
    disorderSpecializationSelected: number | undefined;
    disabled?: boolean;
    componentKey: string;
    technicianField: string;
};

export const TechnicianField = ({
    entityForm,
    ageGroupsSelected,
    disorderSpecializationSelected,
    technicianField,
    disabled,
    componentKey,
}: TechnicianFieldProps) => {


    const baseOrFilter = { _or: [{ disabled: { _eq: false } }, { disabled: { _null: true } }] };

    const filter = { _and: buildTechnicianFilters(baseOrFilter, ageGroupsSelected, disorderSpecializationSelected) } as any;

    const customFilter = (value: string) => {
        const nameFilter = {
            _or: [{ user_id: { first_name: { _icontains: value } } }, { user_id: { last_name: { _icontains: value } } }],
        };
        const result = {
            _and: buildTechnicianFilters(baseOrFilter, ageGroupsSelected, disorderSpecializationSelected, nameFilter),
        } as any;
        return result;
    };

    const asyncAutoCompleteNewProps = {
        key: componentKey,
        entityForm: entityForm as unknown as UseFormReturn,
        fieldName: technicianField,
        placeholder: "Selecione o técnico",
        disabled,
        recordsOptions: {
            entity: "technicians",
            fieldsToQuery: "*,user_id.*",
            labelKey: (option: any) => {
                return `${option.user_id.first_name} ${option.user_id.last_name}`;
            },
            filter,
            customFilter,
            sort: "user_id.first_name",
        },
    };

    return <AsyncAutoCompleteNew {...asyncAutoCompleteNewProps} />;
};

const buildTechnicianFilters = (
    baseOrFilter: any,
    ageGroupsSelected: number | undefined,
    disorderSpecializationSelected: number | undefined,
    nameFilter?: any
) => {
    const filters = [baseOrFilter];
    if (nameFilter) {
        filters.push(nameFilter);
    }
    if (ageGroupsSelected) {
        filters.push({ age_specialization: { age_groups_id: { _eq: ageGroupsSelected } } });
    }
    if (disorderSpecializationSelected) {
        filters.push({ disorder_specialization: { disorders_id: { _eq: disorderSpecializationSelected } } });
    }
    return filters;
};
